<script>

import AdminHeader from "@/components/Admin/header.vue";
import AdminOptionsSidebar from "@/components/Admin/options-sidebar.vue";
import {mapState} from "vuex";
import axios from "axios";
import {CommonMixin} from "@/mixins/commonMethods";

export default {
    name: "AdminOrderItem",
    mixins: [CommonMixin],
    components: {AdminOptionsSidebar, AdminHeader},
    data: () => ({
        isEdit: false,
        currentTab: 'order',
        actualOrder: [],
        defaultValues: {},
        removedItems: [],

        beforeOrderItems: [] // orderItems до того, как начали удалять элементы, в mount-хуке
    }),
    computed: {
        ...mapState({
            dataStoreKeys(state) {
                return state.order.ordersKeys
            },
        }),
        isAllowSave() {
            return true
        },
        options() {
            let array = []
            if (this.dataStoreKeys) {
                for (let key in this.dataStoreKeys) {
                    array.push(key)
                }
            }

            return array
        },
    },
    methods: {
        setItem(models) {
            console.log(models)
            return
        },
        setDefaultValues() {
            if (!this.$route.params.number) {
                return
            }

            let object = {}
            if (this.dataStoreKeys && this.actualOrder) {
                for (let key in this.dataStoreKeys) {
                    object[key] = this.actualOrder[key]
                }
            }
            this.defaultValues = object
        },
        async getOrder() {
            if (this.actualOrder["Номер"]) {
                await this.$store.dispatch(`order/fetchOrderItems`, {orderId: this.actualOrder["ID"]});
                this.actualOrder = JSON.parse(JSON.stringify(this.$store.state.order.orders)).find(item => item["Номер"] === this.actualOrder["Номер"])
            }

            if (this.actualOrder?.orderItems) {
                for (let item of this.actualOrder.orderItems) {
                    item.image = this.setImageURL((await this.getItemImages(item["Код"]))[0])
                }
            }

            this.beforeOrderItems = this.actualOrder.orderItems
        },
        getItemImages(code) {
            const fetchParams = { productCode: code };
            return this.$store.dispatch('fetchImages', fetchParams)
                .then(() => this.$store.state.images.filter(img => img['Тип'] === 'Заглавная'))
                .catch(err => console.error("Error fetching images:", err));
        },
        removeOrderItem(item) {
            this.actualOrder.orderItems.splice(this.actualOrder.orderItems.indexOf(item), 1)
            this.removedItems.push(item)
        }
    },
    async mounted() {
        if (this.$route.params.number) {
            this.isEdit = true;

            const response = await axios.get(process.env.VUE_APP_API_URL + `/orders/getOrderByNumber?orderNumber=${this.$route.params.number}`); // делаем запрос к API
            const renameKeys = obj => {
                return {
                    'Имя адреса': obj.address_name,
                    'Дата создания': obj.create_date,
                    'Квартира': obj.delivery_apartment,
                    'Город': obj.delivery_city,
                    'Страна': obj.delivery_country,
                    'Дом': obj.delivery_house,
                    'Служба доставки': obj.delivery_service,
                    'Индекс': obj.delivery_index,
                    'Регион': obj.delivery_region,
                    'Улица': obj.delivery_street,
                    'Клиент (пользователь)': obj.email,
                    'Дата завершения': obj.finish_date,
                    'Имя': obj.fullname,
                    'ID': obj.order_id,
                    'Номер': obj.order_number,
                    'Статус': obj.order_status,
                    'Телефон': obj.phone,
                };
            };
            if (response.data) {
                this.actualOrder = response.data.map(renameKeys);
                this.$store.commit('order/SET_ORDERS', this.actualOrder);
                this.actualOrder = this.actualOrder[0]
                this.setDefaultValues()
                await this.getOrder()
            }

            this.$store.dispatch(`user/fetchUsers`);
        } else {
            this.$router.go(-1);
        }
    }
}
</script>

<template>
    <admin-header></admin-header>
    <div class="page not-padding">
        <div class="admin-page admin-container-padding">
            <h3 class="page-header">Заказ №{{$route.params.number || 0}}</h3>
            <div class="order-elems" v-if="actualOrder.orderItems">
                <h4 class="block-header">Список товаров</h4>
                <div class="hr"></div>
                <router-link :to="`/products/${item['Код']}`" class="item-info" v-if="actualOrder.orderItems.length > 0" v-for="item of actualOrder.orderItems">
                    <div class="left">
                        <div class="item-img" :style="'background: url(' + item.image + ')'">
                        </div>
                        <div class="item-text">
                            <div class="top">
                                <p class="item-header">{{ item["Название продукта"] }}</p>
                                <p class="item-size">Размер: {{ item["Размер"] }}</p>
                            </div>
                            <p class="item-price">{{ item["Цена по скидке"] }}&#8381;</p>
                        </div>
                    </div>
                    <div class="delete-item" @click.prevent="removeOrderItem(item)">
                        <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect y="0.5" width="30" height="30" rx="10" fill="#6D6F71"/>
                            <path d="M13.75 15.5L10 11.75L11.25 10.5L15 14.25L18.75 10.5L20 11.75L16.25 15.5L20 19.25L18.75 20.5L15 16.75L11.25 20.5L10 19.25L13.75 15.5Z" fill="white"/>
                        </svg>
                    </div>
                </router-link>
                <div v-else>
                    Элементов в заказе больше нет. Он будет удален автоматически после выхода
                </div>
                <div class="hr" v-if="actualOrder.orderItems.length > 0"></div>
                <div class="total-info" v-if="actualOrder.orderItems.length > 0">
                    <span>{{ actualOrder.orderItems.length }} {{ getCaseByNumeral(actualOrder.orderItems.length, 'элемент') }}</span>
                    <span>|</span>
                    <span>Итого: {{ actualOrder.orderItems.reduce((acc, currItem) => { return acc + currItem["Цена по скидке"] }, 0) }}&#8381;</span>
                </div>

            </div>

            <div class="order-address order-elems">
                <h4 class="block-header">Адрес получателя</h4>
                <div class="address-item-outer">
                    <div class="address-item-inner">
                        <p>{{ actualOrder["Служба доставки"] }}</p>
                        <p v-if="actualOrder['Регион'] === actualOrder['Город']">{{`${actualOrder["Индекс"]}, ${actualOrder["Страна"]}, ${actualOrder["Город"]}, ${actualOrder["Улица"]}, д. ${actualOrder["Дом"]} кв. ${actualOrder["Квартира"]}`}}</p>
                        <p v-else>{{`${actualOrder["Индекс"]}, ${actualOrder["Страна"]}, ${actualOrder["Регион"]}, ${actualOrder["Город"]}, ${actualOrder["Улица"]}, д. ${actualOrder["Дом"]} кв. ${actualOrder["Квартира"]}`}}</p>
                        <p>{{ actualOrder["Имя"] }}</p>
                        <p>{{ actualOrder["Телефон"] }}</p>
                    </div>
                </div>
            </div>
        </div>
        <admin-options-sidebar
            class="admin-container-padding"
            :isAllowSave=isAllowSave
            :isEdit=isEdit
            :current-tab=currentTab

            v-if="dataStoreKeys"
            :options=options
            :keys=dataStoreKeys
            :pageInputs=[]
            :defaultValues=defaultValues

            @update:options="setItem"
        >
        </admin-options-sidebar>
    </div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;
.page-header {
    margin-bottom: 30px;
}
.order-elems, .payment-methods {
    background: $white;
    border-radius: 10px;

    display: flex;
    flex-direction: column;
    gap: 10px
}

.order-elems:not(:last-child) {
    margin-bottom: 40px;
}

.item-info {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 2%;
    flex-grow: 1;
    background: $light-gray;
    padding: 2.5%;
    box-sizing: border-box;
    border-radius: 15px;
}

.item-info .left {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2%;
    flex-grow: 1;
}
.order-item {
    background: $light-gray;
    border-radius: 10px;
    padding: 2.5%;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.block-header {
    font-size: 16px;
    font-weight: 500;
    color: $black;
    padding: 0 5px;
}

.item-img {
    width: 75px;
    height: 75px;

    background-size: 100% !important;
    background-position: center;

    border-radius: 10px;
    border: 1px solid $gray;
    box-sizing: border-box;
}

.item-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
}

.item-text .top {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
}

.item-header {
    font-size: 18px;
    font-weight: 500;
    color: $black;
}

.item-size {
    font-size: 14px;
    font-weight: 400;
    color: $hard-gray
}

.item-price {
    font-size: 14px;
    font-weight: 500;
    color: $black;
}
.total-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px
}

.total-info span {
    color: $hard-gray;
    font-size: 14px;
}

.address-item-outer {
    box-sizing: border-box;
    background: $white;
    border-radius: 15px;

    display: flex;
    flex-direction: column;
    gap: 10px
}

.address-item-outer .address-name {
    font-size: 14px;
    font-weight: 500;
}

.address-item-inner {
    background: $silver;
    border-radius: 15px;
    padding: 1.1% 1.4%;
    transition: $transition;
    cursor: pointer;
    border: 1px solid $gray;
    box-sizing: border-box;
}

.address-item-inner:hover {
    background: $silver-hover;
}

.address-item-inner p {
    color: $hard-gray;
    font-size: 14px;
    font-weight: 400;
}
</style>